import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

import { APP_SETTINGS } from '../settings';

@Injectable()
export class AppLoadService {
    serviceName = environment.serviceName;

    constructor(private httpClient: HttpClient) {}

    async getSettings() {
        //TODO: add back
        const settings: any = {} //await this.httpClient.post(`${this.serviceName}/api/utility/applicationSettings`, {}).toPromise();

        // APP_SETTINGS.version = settings.version;
        // APP_SETTINGS.church = settings.church;

        return settings;
    }
}
